/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.getConvoForMembers'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  members: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' }), {
    minLength: 1,
    maxLength: 10,
  }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  convo: /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
    (() => ConvoDefs.convoView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get or create a 1-1 conversation for the given members. Always returns the same direct (non-group) conversation. To create a group conversation, use createGroup. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, [
  'AccountSuspended',
  'BlockedActor',
  'BlockedSubject',
  'MessagesDisabled',
  'NotFollowedBySender',
  'RecipientNotFound',
])

export { main }

export const $lxm = $nsid
